// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__2LL1D","tabHeader":"tab_tabHeader__3Fx5y"};